import {IToJson} from '@toolify/client/src/types/IToJson'
import {
  ICallInviteResponseInstance,
} from '@toolify/server/src/adapters/InstanceApiResponseAdapter/types/responseInstances/ICallInviteResponseInstance'
import {mapCallResponseInstance} from '@toolify/client/src/modules/api/singletons/mapCallResponseInstance'

export function mapCallInviteResponseInstance(
  callInvite: IToJson<ICallInviteResponseInstance>,
): ICallInviteResponseInstance {
  return {
    ...callInvite,
    createdAt: new Date(callInvite.createdAt),
    expiresAt: new Date(callInvite.expiresAt),
    resolvedAt: callInvite.resolvedAt ? new Date(callInvite.resolvedAt) : null,
    call: mapCallResponseInstance(callInvite.call),
  }
}

